import _, { isObject } from "lodash";
import { useState, useEffect, useRef, Fragment } from "react";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import DialogComponent, { DrawerComponent, Modal } from "src/components/DialogComponent";
import TGButton from "src/components/ui/TGButton";
import { FlexCol, FlexRow } from "src/utils/flexLayouts";
import { Circle } from "src/components/ui-icons/myTasks/circle";
import { CirclePlus } from "src/components/ui-icons/myTasks/circlePlus";
import Collapsible from 'react-collapsible';
import Button from "src/components/Button";
import { twMerge } from "tailwind-merge";
import { Medal } from "src/components/ui-icons/myTasks/medal";
import { TreeTrash } from "src/components/ui-icons/myTasks/trash";
import { RichTextarea, createRegexRenderer } from "rich-textarea";
import { RoundBoxMinusTree } from "src/components/ui-icons/myTasks/round-box-minus";
import { RoundBoxPlusTree } from "src/components/ui-icons/myTasks/round-box-plus";
import { myTasks5WayListName, myTasksSDCA5WayListName } from "src/api/config/myTasks5Way.config";
import { getItemsRequest, updateItemRequest } from "src/modules/spItems/api";
import { AddButton } from "src/components/ui-icons/buttons";
import { myTasksTreeCategoriesListName } from "src/api/config/myTasksLists.config";
import Loading from "src/components/Loading";
import { Menu, Transition } from "@headlessui/react";
import { ArrowDown, ArrowUp } from "src/components/ui-icons/card";
import { Continue } from "src/components/ui-icons/myTasks/continue";
import { TooltipItem } from "src/utils/Tooltip";
import { FiveWhyType } from "src/api/config/systemSwitch";
import { selectCurrentUser } from "src/modules/users/selector";


const CollapsibleOpenHandle = (key: string, setCalculateHeight: any, calculateHeight: any) => {
    const childrenTreeElems = document.querySelectorAll(`[data-parent='${key}']`);
    childrenTreeElems.forEach((childrenTreeElem: any) => {
        childrenTreeElem.style.display = "flex";
        childrenTreeElem.classList.remove("tree_item-close");
        childrenTreeElem.classList.add("tree_item-open");
        CollapsibleOpenHandle(childrenTreeElem.id, setCalculateHeight, calculateHeight);
    });
    setCalculateHeight(!calculateHeight);
}

const CollapsibleCloseHandle = (key: string, setCalculateHeight: any, calculateHeight: any) => {
    const childrenTreeElems = document.querySelectorAll(`[data-parent='${key}']`);
    childrenTreeElems.forEach((childrenTreeElem: any) => {
        childrenTreeElem.style.display = 'none';
        CollapsibleCloseHandle(childrenTreeElem.id, setCalculateHeight, calculateHeight);
    });
    setCalculateHeight(!calculateHeight);
}

const hoverBorderToogle = (key: string, add: boolean) => {
    const childrenTreeElems = document.querySelectorAll(`[data-parent='${key}']`);
    childrenTreeElems.forEach((childrenTreeElem: any) => {
        const innerElem = childrenTreeElem.querySelector('.treeItem-inner');
        if (innerElem) {
            if (add) {
                innerElem.style.border = "1px solid #8899A8";

            } else {
                innerElem.style.border = "none";
            }
        }
        hoverBorderToogle(childrenTreeElem.id, add);
    });
}

const distanceBetweenElements = (elementOne: any, elementTwo: any) => {

    let distance = -1;

    const x1 = elementOne.getBoundingClientRect().top;
    const y1 = elementOne.getBoundingClientRect().left;
    const x2 = elementTwo.getBoundingClientRect().top;
    const y2 = elementTwo.getBoundingClientRect().left;
    const xDistance = x1 - x2;
    const yDistance = y1 - y2;

    distance = Math.sqrt(
        (xDistance * xDistance) + (yDistance * yDistance)
    );

    return distance;
}

const TreeItem = ({ treeItem, level, margin, addTreeHandle, lastTreeElem, viewMode, changeTreeElemHandle, setRemoveTreeItemKey, setRemoveModalShow, checkedRootTreeItem, type5Way, noticeTreeItem, setNoticeTreeItem, hasRoot, checkedSystemTreeItem, flatView = false }: any) => {

    const [reason, setReason] = useState('');
    const [notice, setNotice] = useState('');
    const MIN_TEXTAREA_HEIGHT = 22;
    const [distanceToChildren, setDistanceToChildren] = useState(0);
    const [distanceToParent, setDistanceToParent] = useState(0);
    const [calculateHeight, setCalculateHeight] = useState(false);

    const renderer = createRegexRenderer([[/(^|\W)(#[а-я\w][а-я\w-]*)/gi, { color: "rgb(0,98,155)" }]]);

    const editorReason = useRef();

    const editorNotice = useRef();

    useEffect(() => {
        setNotice(treeItem.notice);
        setReason(treeItem.reason);
    }, []);

    useEffect(() => {
        if (!viewMode) {
            // Reset height - important to shrink on delete
            //@ts-ignore
            editorReason.current.style.height = "inherit";
            // Set height
            //@ts-ignore
            editorReason.current.style.height = `${Math.max(editorReason.current.scrollHeight, MIN_TEXTAREA_HEIGHT)}px`;
            changeTreeElemHandle(treeItem.key, reason, 'reason');
        }
    }, [reason]);

    useEffect(() => {
        if (!viewMode) {
            // Reset height - important to shrink on delete
            //@ts-ignore
            editorNotice.current.style.height = "inherit";
            // Set height
            //@ts-ignore
            editorNotice.current.style.height = `${Math.max(editorNotice.current.scrollHeight, MIN_TEXTAREA_HEIGHT)}px`;
            changeTreeElemHandle(treeItem.key, notice, 'notice');
        }
    }, [notice]);

    useEffect(() => {
        setTimeout(() => {
            //@ts-ignore
            const div1rect = document.querySelector(`#treeItem_${treeItem.key}`);
            const div2rect = document.querySelectorAll(`[data-parent='treeItem_${treeItem.key}']`).length > 0 && document.querySelectorAll(`[data-parent='treeItem_${treeItem.key}']`)[document.querySelectorAll(`[data-parent='treeItem_${treeItem.key}']`).length - 1];

            if (div2rect) {
                const distance = distanceBetweenElements(div1rect, div2rect);
                setDistanceToChildren(distance);
            }
        }, 150)

        setTimeout(() => {
            //@ts-ignore
            const div1rect = document.querySelector(`#treeItem_${treeItem.parent}`);
            const div2rect = document.querySelector(`#treeItem_${treeItem.key}`);

            if (div1rect) {
                const distance = distanceBetweenElements(div1rect, div2rect);
                setDistanceToParent(distance);
            }
        }, 300)
    }, [JSON.stringify(treeItem), calculateHeight, viewMode]);

    return (
        <FlexRow id={`treeItem_${treeItem.key}`} data-parent={`treeItem_${treeItem.parent || 0}`} style={{ marginLeft: `${flatView ? 0 : margin}px`, zIndex: 200 - Number(level) }} className={twMerge(
            "w-full max-w-[771px] gap-[10px] relative bg-white",
            flatView && "max-w-none",
            treeItem.children.length > 0 && "tree_item-open"
        )}>
            {!flatView && treeItem.children.length > 0 &&
                <div style={{ zIndex: -1, height: `${distanceToChildren - 26}px`, width: "18px", left: `12px` }} className="absolute top-[44px] border-l border-[#9CA3AF] treeElem-border"></div>
            }

            {!flatView && distanceToParent &&
                <div style={{ zIndex: -1, borderRadius: "0 0 0 8px", height: `${distanceToParent}px`, width: "18px", left: `-${margin - ((margin - 40) + 12)}px`, top: `-${distanceToParent - 32}px` }} className="absolute border-b border-l border-[#9CA3AF]"></div> ||
                !flatView &&
                <div style={{ zIndex: -1, borderRadius: "0 0 0 8px", height: "12px", width: "18px", left: `-${margin - ((margin - 40) + 12)}px` }} className="absolute top-[22px] border-b border-l border-[#9CA3AF]"></div>
            }

            {!flatView && treeItem.children.length === 0 &&
                <FlexRow className="mt-[20px]">
                    <Circle />
                </FlexRow> ||
                !flatView && <>
                    <FlexRow title="Свернуть" onClick={() => {
                        const treeElem = document.querySelector(`#treeItem_${treeItem.key}`);
                        if (treeElem) {
                            treeElem.classList.remove("tree_item-open");
                            treeElem.classList.add("tree_item-close");
                        }
                        CollapsibleCloseHandle(`treeItem_${treeItem.key}`, setCalculateHeight, calculateHeight);
                    }} className="main_tree_minus mt-[20px] cursor-pointer hover:text-[#012169] text-[#8899A8]">
                        <RoundBoxMinusTree />
                    </FlexRow>
                    <FlexRow title="Развернуть" onClick={() => {
                        const treeElem = document.querySelector(`#treeItem_${treeItem.key}`);
                        if (treeElem) {
                            treeElem.classList.remove("tree_item-close");
                            treeElem.classList.add("tree_item-open");
                        }
                        CollapsibleOpenHandle(`treeItem_${treeItem.key}`, setCalculateHeight, calculateHeight);
                    }} className="main_tree_plus mt-[20px] cursor-pointer hover:text-[#012169] text-[#8899A8]">
                        <RoundBoxPlusTree />
                    </FlexRow>
                </>
            }
            <div onMouseEnter={() => hoverBorderToogle(`treeItem_${treeItem.key}`, true)} onMouseLeave={() => hoverBorderToogle(`treeItem_${treeItem.key}`, false)} className={twMerge(
                "treeItem-inner w-full rounded-md bg-[#F3F4F6] p-2.5 mb-2.5 min-h-[96px]",
                flatView && "min-w-0 flex-1 p-4 mb-4"
            )}>
                <FlexRow className="gap-2">
                    <FlexCol className="w-full">
                        {!viewMode && (
                            <>
                                <FlexRow className="tree_reason">
                                    <RichTextarea
                                        className={`block w-full text-base placeholder:text-[#111928] text-[#111928]`}
                                        style={{
                                            minHeight: MIN_TEXTAREA_HEIGHT,
                                            resize: "none",
                                            width: "100%",
                                            overflow: "hidden"
                                        }}
                                        //@ts-ignore
                                        ref={editorReason}
                                        placeholder="Потому что..."
                                        value={reason}
                                        onChange={e => {
                                            setReason(e.target.value);
                                        }}
                                    >
                                        {renderer}
                                    </RichTextarea>
                                </FlexRow>
                                <FlexRow className="tree_notice">
                                    <RichTextarea
                                        className={`block text-sm w-full placeholder:text-[#637381] text-[#637381] outline-0 border-none`}
                                        style={{
                                            minHeight: MIN_TEXTAREA_HEIGHT,
                                            resize: "none",
                                            width: "100%",
                                            overflow: "hidden"
                                        }}
                                        //@ts-ignore
                                        ref={editorNotice}
                                        placeholder={type5Way === FiveWhyType ? "Подтверждение..." : "Доказательство..."}
                                        value={notice}
                                        onChange={e => setNotice(e.target.value)}
                                    >
                                        {renderer}
                                    </RichTextarea>
                                </FlexRow>
                            </>
                        ) || (
                                <>
                                    <FlexRow className="tree_reason">
                                        <div className="block w-full text-base text-[#111928]" dangerouslySetInnerHTML={{
                                            __html: treeItem.reason.replace(
                                                /(^|\W)(#[а-я\w][а-я\w-]*)/gi,
                                                '<span style="color: rgb(0,98,155)">$&</span>'
                                            ),
                                        }} />
                                    </FlexRow>
                                    <FlexRow className="tree_notice">
                                        <div className="block text-sm w-full text-[#637381]" dangerouslySetInnerHTML={{
                                            __html: treeItem.notice.replace(
                                                /(^|\W)(#[а-я\w][а-я\w-]*)/gi,
                                                '<span style="color: rgb(0,98,155)">$&</span>'
                                            ),
                                        }} />
                                    </FlexRow>
                                </>
                            )}
                    </FlexCol>
                    {type5Way !== FiveWhyType &&
                        <>
                            {((!hasRoot && lastTreeElem) || treeItem.root) &&
                                <FlexRow title="Техническая причина" onClick={(e) => {
                                    if (!viewMode) {
                                        e.stopPropagation();
                                        if (treeItem.root) {
                                            checkedRootTreeItem(treeItem.key);
                                        } else {
                                            if (reason) {
                                                checkedRootTreeItem(treeItem.key);
                                            } else {
                                                setNoticeTreeItem(!noticeTreeItem)
                                            }
                                        }
                                    }
                                }} className={twMerge(
                                    "mt-[10px] cursor-pointer hover:text-[#012169]",
                                    treeItem.root && "text-[#F2A900]" || "text-[#9CA3AF]"
                                )}>
                                    <Medal />
                                </FlexRow>
                            }
                            {hasRoot && lastTreeElem && !treeItem.root &&
                                <FlexRow title="Системная причина" onClick={(e) => {
                                    if (!viewMode) {
                                        e.stopPropagation();
                                        if (treeItem.root) {
                                            checkedSystemTreeItem(treeItem.key);
                                        } else {
                                            if (reason) {
                                                checkedSystemTreeItem(treeItem.key);
                                            } else {
                                                setNoticeTreeItem(!noticeTreeItem)
                                            }
                                        }
                                    }
                                }} className={twMerge(
                                    "mt-[10px] cursor-pointer hover:text-[#012169]",
                                    treeItem.system && "text-[#E10E0E]" || "text-[#9CA3AF]"
                                )}>
                                    <Medal />
                                </FlexRow>
                            }
                        </>
                    }
                    {type5Way === FiveWhyType && lastTreeElem &&
                        <FlexRow title="Корневая причина" onClick={(e) => {
                            if (!viewMode) {
                                e.stopPropagation();
                                if (treeItem.root) {
                                    checkedRootTreeItem(treeItem.key);
                                } else {
                                    if (reason) {
                                        checkedRootTreeItem(treeItem.key);
                                    } else {
                                        setNoticeTreeItem(!noticeTreeItem)
                                    }
                                }
                            }
                        }} className={twMerge(
                            "mt-[10px] cursor-pointer [@media(hover:hover)]:hover:text-[#012169]",
                            treeItem.root && "text-[#F2A900]" || "text-[#9CA3AF]"
                        )}>
                            <Medal />
                        </FlexRow>
                    }
                    {!viewMode &&
                        <FlexRow title="Удалить" onClick={(e) => {
                            e.stopPropagation();
                            setRemoveTreeItemKey(treeItem.key);
                            setRemoveModalShow(true);
                        }} className="mt-[10px] cursor-pointer hover:text-[#012169] text-[#8899A8]">
                            <TreeTrash />
                        </FlexRow>
                    }
                </FlexRow>
            </div>
            {!viewMode && ((treeItem.children.length === 0 && type5Way === FiveWhyType) || (type5Way === 'DeviationReport' && !treeItem.system)) &&
                <FlexRow title="Добавить Почему" className="mt-[20px] cursor-pointer text-[#8899A8] hover:text-[#012169]" onClick={(e) => {
                    e.stopPropagation();
                    if (treeItem.reason) {
                        addTreeHandle({ level, parentKey: treeItem.key, category: treeItem.category });
                    } else {
                        setNoticeTreeItem(!noticeTreeItem)
                    }
                }}>
                    <CirclePlus />
                </FlexRow>
            }
        </FlexRow>
    );
}

const TreeItemScreenshot = ({ treeItem, level, margin, lastTreeElem }: any) => {

    return (
        <div style={{ marginLeft: `${margin}px`, zIndex: 200 - Number(level), width: '100%', maxWidth: '771px', gap: '10px', position: 'relative', backgroundColor: '#fff', display: 'flex' }}>
            <div style={{ width: '100%', borderRadius: '8px', backgroundColor: '#F3F4F6', padding: '16px', marginBottom: '16px', minHeight: '96px' }}>
                <div style={{ gap: '10px', display: 'flex' }}>
                    <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
                        <div style={{ width: '100%', color: '#111928' }} dangerouslySetInnerHTML={{
                            __html: treeItem.reason.replace(
                                /(^|\W)(#[а-я\w][а-я\w-]*)/gi,
                                '<span style="color: rgb(0,98,155)">$&</span>'
                            ),
                        }} />
                        <div style={{ width: '100%', color: '#637381', fontSize: '14px' }} dangerouslySetInnerHTML={{
                            __html: treeItem.notice.replace(
                                /(^|\W)(#[а-я\w][а-я\w-]*)/gi,
                                '<span style="color: rgb(0,98,155)">$&</span>'
                            ),
                        }} />
                    </div>
                    {treeItem.root &&
                        <div style={{ display: 'flex', marginTop: '10px', color: '#F2A900' }}>
                            <Medal />
                        </div>
                    }
                    {treeItem.system &&
                        <div style={{ display: 'flex', marginTop: '10px', color: '#E10E0E' }}>
                            <Medal />
                        </div>
                    }
                </div>
            </div>
        </div>
    );
}

const TreeCategory = ({ treeItem, level, margin, addTreeHandle, viewMode, changeTreeElemHandle, setRemoveTreeItemKey, setRemoveModalShow, categories, setRemoveTreeItemCategory, flatView = false }: any) => {

    const [distance, setDistance] = useState(0);
    const [calculateHeight, setCalculateHeight] = useState(false);


    useEffect(() => {
        setTimeout(() => {
            //@ts-ignore
            const div1rect = document.querySelector(`#treeItem_${treeItem.key}`);
            const div2rect = document.querySelectorAll(`[data-parent='treeItem_${treeItem.key}']`).length > 0 && document.querySelectorAll(`[data-parent='treeItem_${treeItem.key}']`)[document.querySelectorAll(`[data-parent='treeItem_${treeItem.key}']`).length - 1];

            if (div2rect) {
                const distance = distanceBetweenElements(div1rect, div2rect);
                setDistance(distance);
            }
        }, 150)
    }, [JSON.stringify(treeItem), calculateHeight, viewMode]);

    return (
        <>
            <FlexRow id={`treeItem_${treeItem.key}`} data-parent={`treeItem_${treeItem.parent || 0}`} style={{ marginLeft: `${flatView ? 0 : margin}px`, zIndex: 400 }} className={twMerge(
                "w-full max-w-[771px] gap-[10px] relative bg-white",
                flatView && "max-w-none",
                treeItem.children.length > 0 && "tree_item-open"
            )}>
                {!flatView && treeItem.children.length > 0 &&
                    <div style={{ zIndex: -1, borderRadius: treeItem.children.length === 1 && "0px 0px 0px 8px" || "0px", height: `${distance - 25}px`, width: "18px", left: `12px`, top: '46px' }} className="absolute border-l border-[#9CA3AF] treeElem-border"></div>
                }

                {!flatView &&
                    <div style={{ zIndex: -1, borderRadius: "0 0 0 8px", height: "calc(100% - 22px)", width: "18px", left: `-${margin - 12}px` }} className="absolute top-[0px] border-b border-l border-[#9CA3AF]"></div>
                }

                {!flatView && treeItem.children.length === 0 &&
                    <FlexRow className="mt-[20px]">
                        <Circle />
                    </FlexRow> ||
                    !flatView && <>
                        <FlexRow title="Свернуть" onClick={() => {
                            const treeElem = document.querySelector(`#treeItem_${treeItem.key}`);
                            if (treeElem) {
                                treeElem.classList.remove("tree_item-open");
                                treeElem.classList.add("tree_item-close");
                            }
                            CollapsibleCloseHandle(`treeItem_${treeItem.key}`, setCalculateHeight, calculateHeight);
                        }} className="main_tree_minus mt-[20px] cursor-pointer hover:text-[#012169] text-[#8899A8]">
                            <RoundBoxMinusTree />
                        </FlexRow>
                        <FlexRow title="Развернуть" onClick={() => {
                            const treeElem = document.querySelector(`#treeItem_${treeItem.key}`);
                            if (treeElem) {
                                treeElem.classList.remove("tree_item-close");
                                treeElem.classList.add("tree_item-open");
                            }
                            CollapsibleOpenHandle(`treeItem_${treeItem.key}`, setCalculateHeight, calculateHeight);
                        }} className="main_tree_plus mt-[20px] cursor-pointer hover:text-[#012169] text-[#8899A8]">
                            <RoundBoxPlusTree />
                        </FlexRow>
                    </>
                }
                <FlexRow onMouseEnter={() => hoverBorderToogle(`treeItem_${treeItem.key}`, true)} onMouseLeave={() => hoverBorderToogle(`treeItem_${treeItem.key}`, false)} className={twMerge(
                    "treeItem-inner gap-2 items-center w-full p-2.5 mb-2.5 rounded-md bg-[#EDE9FE] border border-[#8646F4] min-h-[45.6px]",
                    flatView && "min-w-0 flex-1 p-4 mb-4"
                )}>
                    <FlexCol className="w-full">
                        {treeItem.category}
                    </FlexCol>
                    {!viewMode &&
                        <FlexRow title="Удалить" className="gap-[10px]">

                            <FlexRow onClick={(e) => {
                                e.stopPropagation();
                                setRemoveTreeItemCategory(true);
                                setRemoveTreeItemKey(treeItem.key);
                                setRemoveModalShow(true);
                            }} className="cursor-pointer hover:text-[#012169] text-[#8899A8]">
                                <TreeTrash />
                            </FlexRow>
                        </FlexRow>
                    }
                </FlexRow>

                {!viewMode &&
                    <FlexRow title="Добавить Причину" className="mt-[20px] cursor-pointer text-[#8899A8] hover:text-[#012169]" onClick={(e) => {
                        e.stopPropagation();
                        addTreeHandle({ level, parentKey: treeItem.key, category: treeItem.category });
                    }}>
                        <CirclePlus />
                    </FlexRow>
                }
            </FlexRow >
            {!viewMode &&
                <Menu as="div" style={{ zIndex: 430, width: 'min-content' }} className="relative left-[710px] top-[-40px] flex text-left items-center">
                    {({ open }) => (
                        <>
                            <Menu.Button
                                onClick={(e) => e.stopPropagation()}
                                className={twMerge(open ? "button-state-active" : "", "flex rounded-lg button-state")}
                            >
                                {open ?
                                    <ArrowUp />
                                    :
                                    <ArrowDown />
                                }
                            </Menu.Button>

                            <Transition
                                as={Fragment}
                                enter="transition ease-out duration-100"
                                enterFrom="transform opacity-0 scale-95"
                                enterTo="transform opacity-100 scale-100"
                                leave="transition ease-in duration-75"
                                leaveFrom="transform opacity-100 scale-100"
                                leaveTo="transform opacity-0 scale-95"
                            >
                                <Menu.Items style={{ zIndex: 450 }} className="absolute top-0 origin-top-right ml-2.5 bg-white rounded-lg left-full shadow-custom ring-1 ring-black ring-opacity-5 focus:outline-none min-w-[180px]">
                                    {categories.map((item: any) => (
                                        <Menu.Item disabled={item.ID === 19 && true || false} key={item.ID}>
                                            <FlexRow onClick={(e) => {
                                                e.stopPropagation();
                                                changeTreeElemHandle(treeItem.key, item.Title, 'category')
                                            }} className={`${item.ID === 19 && "cursor-not-allowed" || "cursor-pointer"} items-center px-[20px] py-[8px] gap-x-2 hover:bg-[#F5F7FD]`}>
                                                <div className="flex flex-col text-[#012169]">{item.Title}</div>
                                            </FlexRow>
                                        </Menu.Item>
                                    ))}
                                </Menu.Items>
                            </Transition>
                        </>
                    )}
                </Menu >
            }
        </>
    );
}

const TreeItemCategoryScreenshot = ({ treeItem, level, margin }: any) => {

    return (
        <div style={{ marginLeft: `${margin}px`, zIndex: 400, width: '100%', maxWidth: '771px', gap: '10px', position: 'relative', backgroundColor: '#fff' }}>
            <div style={{ display: 'flex', gap: '10px', alignItems: 'center', width: '100%', padding: '16px', marginBottom: '16px', borderRadius: '8px', backgroundColor: '#EDE9FE', border: '1px, solid #8646F4', minHeight: '45.6px' }}>
                <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
                    {treeItem.category}
                </div>
            </div>
        </div >
    );
}

const TreeReason = ({ treeItem, level, margin, addTreeHandle, viewMode, changeTreeElemHandle, setRemoveTreeItemKey, setRemoveModalShow, idxReason, reasonTreeItem, setReasonTreeItem, flatView = false }: any) => {
    const [reason, setReason] = useState('');
    const [notice, setNotice] = useState('');
    const MIN_TEXTAREA_HEIGHT = 22;
    const [distance, setDistance] = useState(0);
    const [calculateHeight, setCalculateHeight] = useState(false);

    const renderer = createRegexRenderer([[/(^|\W)(#[а-я\w][а-я\w-]*)/gi, { color: "rgb(0,98,155)" }]]);

    const editorReason = useRef();

    const editorNotice = useRef();

    useEffect(() => {
        setNotice(treeItem.notice_1);
        setReason(treeItem.reason_1);
    }, []);

    useEffect(() => {
        if (!viewMode) {
            // Reset height - important to shrink on delete
            //@ts-ignore
            editorReason.current.style.height = "inherit";
            // Set height
            //@ts-ignore
            editorReason.current.style.height = `${Math.max(editorReason.current.scrollHeight, MIN_TEXTAREA_HEIGHT)}px`;
            changeTreeElemHandle(treeItem.key, reason, 'reason_1');
        }
    }, [reason]);

    useEffect(() => {
        if (!viewMode) {
            // Reset height - important to shrink on delete
            //@ts-ignore
            editorNotice.current.style.height = "inherit";
            // Set height
            //@ts-ignore
            editorNotice.current.style.height = `${Math.max(editorNotice.current.scrollHeight, MIN_TEXTAREA_HEIGHT)}px`;
            changeTreeElemHandle(treeItem.key, notice, 'notice_1');
        }
    }, [notice]);

    useEffect(() => {
        setTimeout(() => {
            //@ts-ignore
            const div1rect = document.querySelector(`#treeItem_${treeItem.key}`);
            const div2rect = document.querySelectorAll(`[data-parent='treeItem_${treeItem.key}']`).length > 0 && document.querySelectorAll(`[data-parent='treeItem_${treeItem.key}']`)[document.querySelectorAll(`[data-parent='treeItem_${treeItem.key}']`).length - 1];

            if (div2rect) {
                const distance = distanceBetweenElements(div1rect, div2rect);
                setDistance(distance);
            }
        }, 150)
    }, [JSON.stringify(treeItem), calculateHeight, viewMode]);

    return (
        <FlexRow id={`treeItem_${treeItem.key}`} data-parent={`treeItem_${treeItem.parent || 0}`} style={{ marginLeft: `${flatView ? 0 : margin}px`, zIndex: 300 }} className={twMerge(
            "w-full max-w-[771px] gap-[10px] relative bg-white",
            flatView && "max-w-none",
            treeItem.children.length > 0 && "tree_item-open"
        )}>
            {!flatView && treeItem.children.length > 0 &&
                <div style={{ zIndex: -1, height: `${distance - 26}px`, width: "18px", left: `12px` }} className="absolute top-[44px] border-l border-[#9CA3AF] treeElem-border"></div>
            }

            {!flatView &&
                <div style={{ zIndex: -1, borderRadius: "0 0 0 8px", height: "12px", width: "18px", left: `-${margin - ((margin - 40) + 12)}px` }} className="absolute top-[22px] border-b border-l border-[#9CA3AF]"></div>
            }

            {!flatView && treeItem.children.length === 0 &&
                <FlexRow className="mt-[20px]">
                    <Circle />
                </FlexRow> ||
                !flatView && <>
                    <FlexRow title="Свернуть" onClick={() => {
                        const treeElem = document.querySelector(`#treeItem_${treeItem.key}`);
                        if (treeElem) {
                            treeElem.classList.remove("tree_item-open");
                            treeElem.classList.add("tree_item-close");
                        }
                        CollapsibleCloseHandle(`treeItem_${treeItem.key}`, setCalculateHeight, calculateHeight);
                    }} className="main_tree_minus mt-[20px] cursor-pointer hover:text-[#012169] text-[#8899A8]">
                        <RoundBoxMinusTree />
                    </FlexRow>
                    <FlexRow title="Развернуть" onClick={() => {
                        const treeElem = document.querySelector(`#treeItem_${treeItem.key}`);
                        if (treeElem) {
                            treeElem.classList.remove("tree_item-close");
                            treeElem.classList.add("tree_item-open");
                        }
                        CollapsibleOpenHandle(`treeItem_${treeItem.key}`, setCalculateHeight, calculateHeight);
                    }} className="main_tree_plus mt-[20px] cursor-pointer hover:text-[#012169] text-[#8899A8]">
                        <RoundBoxPlusTree />
                    </FlexRow>
                </>
            }
            <div onMouseEnter={() => hoverBorderToogle(`treeItem_${treeItem.key}`, true)} onMouseLeave={() => hoverBorderToogle(`treeItem_${treeItem.key}`, false)} className={twMerge(
                "treeItem-inner w-full rounded-md bg-[#F3F4F6] p-2.5 mb-2.5 min-h-[96px]",
                flatView && "min-w-0 flex-1 p-4 mb-4"
            )}>
                <FlexRow className="gap-2">
                    <FlexCol className="w-full">
                        {!viewMode && (
                            <>
                                <FlexRow className="tree_reason">
                                    <RichTextarea
                                        className={`block w-full text-base placeholder:text-[#111928] text-[#111928]`}
                                        style={{
                                            minHeight: MIN_TEXTAREA_HEIGHT,
                                            resize: "none",
                                            width: "100%",
                                            overflow: "hidden"
                                        }}
                                        //@ts-ignore
                                        ref={editorReason}
                                        placeholder={`Причина ${idxReason}...`}
                                        value={reason}
                                        onChange={e => setReason(e.target.value)}
                                    >
                                        {renderer}
                                    </RichTextarea>
                                </FlexRow>
                                <FlexRow className="tree_notice">
                                    <RichTextarea
                                        className={`block text-sm w-full placeholder:text-[#637381] text-[#637381] outline-0 border-none`}
                                        style={{
                                            minHeight: MIN_TEXTAREA_HEIGHT,
                                            resize: "none",
                                            width: "100%",
                                            overflow: "hidden"
                                        }}
                                        //@ts-ignore
                                        ref={editorNotice}
                                        placeholder="Опишите причину..."
                                        value={notice}
                                        onChange={e => setNotice(e.target.value)}
                                    >
                                        {renderer}
                                    </RichTextarea>
                                </FlexRow>
                            </>
                        ) || (
                                <>
                                    <FlexRow className="tree_reason">
                                        <div className="block w-full text-base text-[#111928]" dangerouslySetInnerHTML={{
                                            __html: treeItem.reason_1.replace(
                                                /(^|\W)(#[а-я\w][а-я\w-]*)/gi,
                                                '<span style="color: rgb(0,98,155)">$&</span>'
                                            ),
                                        }} />
                                    </FlexRow>
                                    <FlexRow className="tree_notice">
                                        <div className="block text-sm w-full text-[#637381]" dangerouslySetInnerHTML={{
                                            __html: treeItem.notice_1.replace(
                                                /(^|\W)(#[а-я\w][а-я\w-]*)/gi,
                                                '<span style="color: rgb(0,98,155)">$&</span>'
                                            ),
                                        }} />
                                    </FlexRow>
                                </>
                            )}
                    </FlexCol>
                    <FlexRow title={(treeItem.continue && treeItem.children.length > 0 && "Удалите все вложенные Почему, чтобы закрыть ветку") || (treeItem.continue && treeItem.children.length === 0 && 'Закрыть ветку') || 'Продолжить ветку'} onClick={(e) => {
                        if (!viewMode) {
                            e.stopPropagation();
                            if (treeItem.children.length === 0) {
                                changeTreeElemHandle(treeItem.key, !treeItem.continue, 'continue');
                            }
                        }
                    }} className={twMerge(
                        "mt-[10px] cursor-pointer hover:text-[#012169]",
                        treeItem.continue && "text-[#BA0C2F]" || "text-[#9CA3AF]"

                    )}>
                        <Continue />
                    </FlexRow>
                    {!viewMode &&
                        <FlexRow title="Удалить" onClick={(e) => {
                            e.stopPropagation();
                            setRemoveTreeItemKey(treeItem.key);
                            setRemoveModalShow(true);
                        }} className="mt-[10px] cursor-pointer hover:text-[#012169] text-[#8899A8]">
                            <TreeTrash />
                        </FlexRow>
                    }
                </FlexRow>
            </div >
            {!viewMode && treeItem.continue &&
                <FlexRow title="Добавить Почему" className="mt-[20px] cursor-pointer text-[#8899A8] hover:text-[#012169]" onClick={(e) => {
                    e.stopPropagation();
                    if (treeItem.reason_1) {
                        addTreeHandle({ level, parentKey: treeItem.key, category: treeItem.category });
                    } else {
                        setReasonTreeItem(!reasonTreeItem)
                    }
                }}>
                    <CirclePlus />
                </FlexRow>
            }
        </FlexRow >
    );
}

const TreeReasonScreenshot = ({ treeItem, level, margin }: any) => {

    return (
        <div style={{ display: 'flex', marginLeft: `${margin}px`, zIndex: 300, width: '100%', maxWidth: '771px', gap: '10px', position: 'relative', backgroundColor: '#fff' }}>
            <div style={{ width: '100%', borderRadius: '8px', backgroundColor: '#F3F4F6', padding: '16px', marginBottom: '16px', minHeight: '96px' }}>
                <div style={{ display: 'flex', gap: '10px' }}>
                    <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
                        <div style={{ width: '100%', color: '#111928' }} dangerouslySetInnerHTML={{
                            __html: treeItem.reason_1.replace(
                                /(^|\W)(#[а-я\w][а-я\w-]*)/gi,
                                '<span style="color: rgb(0,98,155)">$&</span>'
                            ),
                        }} />
                        <div style={{ width: '100%', color: '#637381' }} dangerouslySetInnerHTML={{
                            __html: treeItem.notice_1.replace(
                                /(^|\W)(#[а-я\w][а-я\w-]*)/gi,
                                '<span style="color: rgb(0,98,155)">$&</span>'
                            ),
                        }} />
                    </div>
                    <FlexRow style={{ marginTop: '10px', color: treeItem.continue && '#BA0C2F' || '#9CA3AF' }}>
                        <Continue />
                    </FlexRow>
                </div>
            </div >
        </div >
    );
}

export const list_to_tree = (list: any) => {
    let map: any = {}, node, roots = [], i;

    for (i = 0; i < list.length; i += 1) {
        map[list[i].key] = i; // initialize the map
        list[i].children = []; // initialize the children
    }

    for (i = 0; i < list.length; i += 1) {
        node = list[i];
        if (node.parent) {
            // if you have dangling branches check that map[node.parentId] exists
            list[map[node.parent]].children.push(node);
        } else {
            roots.push(node);
        }
    }
    return roots;
}

const Tree = ({
    zIndex,
    card5WayID,
    viewMode,
    detailProplem,
    tree,
    type5Way,
    setCard5WayTree,
    open,
    setOpen,
    setProblemInTree,
    problemInTree,
    isMobileView = false,
    setConfirmUseAiModal,
}: {
    zIndex: number;
    card5WayID: number | null;
    viewMode: boolean;
    detailProplem: string;
    tree: any;
    type5Way?: string;
    setCard5WayTree: any;
    open: any;
    setOpen: any;
    setProblemInTree?: any;
    problemInTree?: any;
    isMobileView?: boolean;
    setConfirmUseAiModal?: any;
}) => {
    const dispatch = useAppDispatch();
    const [renderTree, setRenderTree] = useState<any>([]);
    const [renderScreenshotTree, setRenderScreenShotTree] = useState<any>([]);
    const [simpleTree, setSimpleTree] = useState<any>([]);
    const [simpleTreeHasRoot, setSimpleTreeHasRoot] = useState<any>({});
    const [editData, setEditData] = useState(false);
    const [removeTreeItemKey, setRemoveTreeItemKey] = useState("");
    const [removeTreeItemCategory, setRemoveTreeItemCategory] = useState(false);
    const [removeModalShow, setRemoveModalShow] = useState(false);
    const [customLoading, setCustomLoading] = useState(true);
    const [categories, setCategories] = useState<any>([]);
    const [sdcaItems, setSdcaItems] = useState<any>([]);
    const [distance, setDistance] = useState(0);
    const [noticeMedal, setNoticeMedal] = useState(false);
    const [noticeTreeItem, setNoticeTreeItem] = useState(false);
    const [reasonTreeItem, setReasonTreeItem] = useState(false);
    const [showAddProblemInTreeModal, SetShowAddProblemInTreeModal] = useState(false);
    const [problemRows, setProblemRows] = useState(3);
    const flatMobileView = isMobileView;
    const currentUser: any = useAppSelector(selectCurrentUser);

    const saveTreeHandle = () => {
        if (!problemInTree) {
            SetShowAddProblemInTreeModal(true);
        } else {
            setCustomLoading(true);
            updateItemRequest({ listName: myTasks5WayListName, body: { ID: card5WayID, Tree: JSON.stringify(simpleTree), DetailsInTree: problemInTree } }).then(() => {
                setCard5WayTree(simpleTree);
                setOpen(false);
                setCustomLoading(false);
            });
        }
    }

    const resetTreeHandle = () => {
        setCustomLoading(true);
        setSimpleTree([...tree]);
        setEditData(false);
        setOpen(false);
        setCustomLoading(false);
    }

    useEffect(() => {
        if (open) {
            setSimpleTree([...tree]);
            setEditData(false);
        }
    }, [tree, open]);

    useEffect(() => {
        if (card5WayID) {
            getItemsRequest({ listName: myTasksSDCA5WayListName, filters: { _x0035_Way: card5WayID } }).then((results) => {
                setSdcaItems([...results.items]);
                getItemsRequest({ listName: myTasksTreeCategoriesListName }).then((results) => {
                    setCategories([...results.items]);
                })
            })
        }
    }, [card5WayID, open]);

    useEffect(() => {
        if (categories.length > 0) {
            setCustomLoading(false);
        }
    }, [categories]);

    const addTreeHandle = ({ level, parentKey, category }: { level: number, parentKey?: string, category?: string }) => {
        setEditData(true);
        const tempSimpleTree: any = [...simpleTree];
        tempSimpleTree.forEach((treeItem: any) => {
            if (parentKey && parentKey === treeItem.key) {
                if (type5Way === FiveWhyType) {
                    treeItem['root'] = false;
                }
            }
        });
        setSimpleTree([...tempSimpleTree, {
            key: `${level}_${simpleTree.length}`,
            parent: parentKey || 0,
            reason: '', // Доказательство...
            notice: '', // Потому что...
            reason_1: '', // Доказательство причины... (Диаграмма Ишикавы)
            notice_1: '', // Причина...(Диаграмма Ишикавы)
            system: '', // Системный корень ОоО
            root: false,
            card5WayID: card5WayID,
            level: level,
            children: null,
            category: category,
            continue: false,
            remove: true,
            delete: false
        }]);
    }

    const removeTreeHandleCurrent = (key: string) => {
        if (key) {
            setEditData(true);
            const tempSimpleTree: any = [...simpleTree];
            let category = '';
            tempSimpleTree.forEach((treeItem: any) => {
                if (treeItem.key === key) category = treeItem.category
            });
            tempSimpleTree.forEach((treeItem: any) => {
                if (treeItem.key === key) treeItem['delete'] = true;
            });
            removeTreeHandleChildren(key, tempSimpleTree);
        }
    }

    const removeTreeHandleChildren = (key: string, tempSimpleTree: any) => {
        tempSimpleTree.forEach((treeItem: any) => {
            if (treeItem.parent === key) {
                treeItem['delete'] = true;
                removeTreeHandleChildren(treeItem.key, tempSimpleTree);
            }
        });
        setSimpleTree([...tempSimpleTree.filter((item: any) => !item.delete)]);
        setRemoveTreeItemCategory(false);
        setRemoveModalShow(false);
    }

    const changeCategoryTreeHandleChildren = (key: string, flatTree: any, value?: string) => {
        const tempSimpleTree: any = [...flatTree];
        const tempSimpleTreeChildren: any = tempSimpleTree.filter((treeItem: any) => treeItem.parent === key);
        if (tempSimpleTreeChildren.length > 0) {
            tempSimpleTree.forEach((treeItem: any) => {
                if (key === treeItem.parent) {
                    treeItem['category'] = value;
                    changeCategoryTreeHandleChildren(treeItem.key, tempSimpleTree, value)
                }
            });
        } else {
            setSimpleTree([...tempSimpleTree]);
        }
    }

    const changeTreeElemHandle = (key: string, value: string, field: string) => {
        setEditData(true);
        const tempSimpleTree: any = [...simpleTree];
        if (field === 'category') {
            tempSimpleTree.forEach((treeItem: any) => {
                if (treeItem.key === key) {
                    treeItem[field] = value;
                }
            });
            changeCategoryTreeHandleChildren(key, tempSimpleTree, value);
        } else {
            tempSimpleTree.forEach((treeItem: any) => {
                if (treeItem.key === key) {
                    treeItem[field] = value;
                }
            });
            setSimpleTree([...tempSimpleTree]);
        }
    }

    const checkedRootTreeItem = (key: string) => {
        setEditData(true);
        const tempSimpleTree: any = [...simpleTree];
        tempSimpleTree.forEach((treeItem: any) => {
            if (treeItem.key === key && treeItem['root']) {
                treeItem['root'] = false;
                treeItem['system'] = false;
            } else if (treeItem.key === key && !treeItem['root']) {
                treeItem['root'] = true;
                treeItem['system'] = false;
            }
        });
        setSimpleTree([...tempSimpleTree]);
    }

    const checkedSystemTreeItem = (key: string) => {
        setEditData(true);
        const tempSimpleTree: any = [...simpleTree];
        tempSimpleTree.forEach((treeItem: any) => {
            if (treeItem.key === key && treeItem['system']) {
                treeItem['system'] = false;
                treeItem['root'] = false;
            } else if (treeItem.key === key && !treeItem['system']) {
                treeItem['system'] = true;
                treeItem['root'] = false;
            }
        });
        setSimpleTree([...tempSimpleTree]);
    }

    useEffect(() => {
        setRenderTree([]);
        setRenderScreenShotTree([]);
        const tree = list_to_tree(simpleTree);
        mapTree(tree, flatMobileView ? 0 : 40, 1);
    }, [simpleTree, sdcaItems, flatMobileView]);

    useEffect(() => {
        setTimeout(() => {
            //@ts-ignore
            const div1rect = document.querySelector(`#collapsible_tree`);
            const div2rect = document.querySelectorAll(`[data-parent='treeItem_0']`).length > 0 && document.querySelectorAll(`[data-parent='treeItem_0']`)[document.querySelectorAll(`[data-parent='treeItem_0']`).length - 1];
            if (div2rect) {
                const distance = distanceBetweenElements(div1rect, div2rect);
                setDistance(distance);
            }
        }, 150)
    }, [simpleTree, viewMode, open, type5Way, renderTree, problemInTree]);

    const hasRootInTree = (parent: string, currentTreeItem: any) => {
        const itemsParentInTree = simpleTree.filter((treeItem: any) => treeItem.key === parent);
        if (itemsParentInTree.length > 0) {
            itemsParentInTree.forEach((treeItem: any) => {
                if (!treeItem.root) {
                    hasRootInTree(treeItem.parent, currentTreeItem);
                } else {
                    setSimpleTreeHasRoot((prev: any) => {
                        return {
                            ...prev, ...{
                                [currentTreeItem.key]: true
                            }
                        }
                    });
                }
            });
        } else if (currentTreeItem.root) {
            setSimpleTreeHasRoot((prev: any) => {
                return {
                    ...prev, ...{
                        [currentTreeItem.key]: true
                    }
                }
            });
        } else {
            setSimpleTreeHasRoot((prev: any) => {
                return {
                    ...prev, ...{
                        [currentTreeItem.key]: false
                    }
                }
            });
        }
    }

    const mapTree = (tree: any, margin: any, level: any) => {
        if (tree.length > 0) {
            tree.map((treeItem: any, idx: number) => {
                hasRootInTree(treeItem.parent, treeItem);
                if (type5Way === 'DeviationReport') {
                    if (level === 1) {
                        setRenderTree((prevState: any) => [...prevState, <TreeCategory key={idx + "-" + treeItem.key} treeItem={treeItem} level={level + 1} margin={margin} addTreeHandle={addTreeHandle} viewMode={viewMode} changeTreeElemHandle={changeTreeElemHandle} setRemoveTreeItemKey={setRemoveTreeItemKey} setRemoveModalShow={setRemoveModalShow} categories={categories} setRemoveTreeItemCategory={setRemoveTreeItemCategory} flatView={flatMobileView} />]);
                        setRenderScreenShotTree((prevState: any) => [...prevState, <TreeItemCategoryScreenshot treeItem={treeItem} level={level + 1} margin={margin} />]);
                    } else if (level === 2) {
                        setRenderTree((prevState: any) => [...prevState, <TreeReason key={idx + "-" + treeItem.key} treeItem={treeItem} level={level + 1} margin={margin} addTreeHandle={addTreeHandle} viewMode={viewMode} changeTreeElemHandle={changeTreeElemHandle} setRemoveTreeItemKey={setRemoveTreeItemKey} setRemoveModalShow={setRemoveModalShow} idxReason={idx + 1} setReasonTreeItem={setReasonTreeItem} reasonTreeItem={reasonTreeItem} flatView={flatMobileView} />]);
                        setRenderScreenShotTree((prevState: any) => [...prevState, <TreeReasonScreenshot treeItem={treeItem} level={level + 1} margin={margin} />]);
                    } else {
                        setRenderTree((prevState: any) => [...prevState, <TreeItem key={idx + "-" + treeItem.key} treeItem={treeItem} level={level + 1} margin={margin} addTreeHandle={addTreeHandle} lastTreeElem={treeItem["children"].length === 0} viewMode={viewMode} changeTreeElemHandle={changeTreeElemHandle} setRemoveTreeItemKey={setRemoveTreeItemKey} setRemoveModalShow={setRemoveModalShow} checkedRootTreeItem={checkedRootTreeItem} type5Way={type5Way} sdcaItems={sdcaItems} noticeMedal={noticeMedal} setNoticeMedal={setNoticeMedal} noticeTreeItem={noticeTreeItem} setNoticeTreeItem={setNoticeTreeItem} open hasRoot={simpleTreeHasRoot[treeItem.key]} checkedSystemTreeItem={checkedSystemTreeItem} flatView={flatMobileView} />]);
                        setRenderScreenShotTree((prevState: any) => [...prevState, <TreeItemScreenshot treeItem={treeItem} level={level + 1} margin={margin} lastTreeElem={treeItem["children"].length === 0} />]);
                    }
                    mapTree(treeItem["children"], margin + (flatMobileView ? 0 : 40), level + 1);
                } else {
                    setRenderTree((prevState: any) => [...prevState, <TreeItem key={idx + "-" + treeItem.key} treeItem={treeItem} level={level + 1} margin={margin} addTreeHandle={addTreeHandle} lastTreeElem={treeItem["children"].length === 0} viewMode={viewMode} changeTreeElemHandle={changeTreeElemHandle} setRemoveTreeItemKey={setRemoveTreeItemKey} setRemoveModalShow={setRemoveModalShow} checkedRootTreeItem={checkedRootTreeItem} type5Way={type5Way} sdcaItems={sdcaItems} noticeMedal={noticeMedal} setNoticeMedal={setNoticeMedal} noticeTreeItem={noticeTreeItem} setNoticeTreeItem={setNoticeTreeItem} open flatView={flatMobileView} />]);
                    setRenderScreenShotTree((prevState: any) => [...prevState, <TreeItemScreenshot treeItem={treeItem} level={level + 1} margin={margin} lastTreeElem={treeItem["children"].length === 0} />])
                    mapTree(treeItem["children"], margin + (flatMobileView ? 0 : 40), level + 1);
                }
            });
        }
    };

    useEffect(() => {
        setProblemRows(Math.min(
            10,
            Math.max(
                1,
                (problemInTree || "")
                    .split("\n")
                    .reduce(
                        (rows, line) => rows + Math.max(1, Math.ceil(line.length / 70)),
                        0
                    )
            )));
    }, [problemInTree]);


    return (
        <>
            {type5Way === FiveWhyType &&
                <Button open={open} setOpen={setOpen} classBg="btn-yellow w-full justify-center mb-5" iconEnd={!viewMode} typeIcon={(simpleTree.some((treeItem: any) => treeItem.root || simpleTree.length > 0) && !viewMode) && "pencil" || "add"} text={"Анализ 5Почему"} />
                ||
                <Button open={open} setOpen={setOpen} classBg="btn-white w-full justify-center" icon={(simpleTree.some((treeItem: any) => treeItem.root || simpleTree.length > 0) && !viewMode)} typeIcon="pencil" text={(simpleTree.some((treeItem: any) => treeItem.root || simpleTree.length > 0) && !viewMode) && "Изменить диаграмму Ишикавы" || "Открыть диаграмму Ишикавы"} />
            }

            <DrawerComponent zIndex={zIndex} open={open} toggleDrawer={setOpen} percentage="79">
                <div className="flex flex-col p-10 shrink">
                    {type5Way === FiveWhyType &&
                        <div className="flex flex-row justify-between">
                            <h1 className="mb-8 text-black">Анализ 5Почему</h1>
                            {currentUser.id && currentUser.AI &&
                                <TooltipItem wrapperClassName="flex" position="left" tooltipsText="Обратиться к ИИ">
                                    <div onClick={() => {
                                        localStorage.setItem('typeAI', 'FiveWhyTree');
                                        setCard5WayTree(simpleTree);
                                        setConfirmUseAiModal && setConfirmUseAiModal(true)
                                    }}><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                                            <path d="M36.6673 19.9948C36.6673 29.1995 29.2054 36.6615 20.0006 36.6615C16.6143 36.6615 13.4638 35.6515 10.834 33.9164C8.67299 32.4906 6.86355 30.5752 5.56369 28.3281C4.1456 25.8767 3.33398 23.0305 3.33398 19.9948C3.33398 10.79 10.7959 3.32812 20.0006 3.32812C29.2054 3.32812 36.6673 10.79 36.6673 19.9948Z" fill="#E5E7EB" />
                                            <path d="M5.56369 28.3281L3.33398 36.6615L10.834 33.9164C8.67299 32.4906 6.86355 30.5752 5.56369 28.3281Z" fill="#E5E7EB" />
                                            <path d="M18.1631 1.7041C23.624 1.09066 29.0224 2.99246 32.8877 6.91895L32.8916 6.92285C36.6964 10.6682 38.6009 15.7948 38.2139 21.0781L38.1689 21.5898C37.3231 30.1085 30.6487 36.8422 22.2461 37.8115L21.8447 37.8535C17.8516 38.2221 14.0476 37.3624 10.6719 35.3369L10.5146 35.2422L10.3496 35.3252L4.66211 38.2002C4.33744 38.3623 4.07663 38.415 3.75 38.415C3.28367 38.4149 2.79589 38.2048 2.40527 37.8701L2.40137 37.8672L2.28711 37.7627C1.74013 37.2231 1.57258 36.3849 1.86914 35.6924L1.87402 35.6807L4.37402 29.1807L4.43164 29.0293L4.34961 28.8906C2.38848 25.5812 1.58934 21.7791 1.95703 17.8467C2.87776 9.37599 9.63061 2.56407 18.1592 1.70508L18.1631 1.7041ZM31.3584 8.44727C28.0784 5.10833 23.4839 3.44934 18.7949 3.8125L18.3418 3.85352C10.8755 4.61929 4.87315 10.5538 4.10645 17.9014C3.72392 21.5993 4.55318 25.1754 6.5332 28.2412L6.53516 28.2451C6.72801 28.5344 6.77093 28.8537 6.63184 29.1787H6.63086L6.62695 29.1904L4.31445 35.1904L4.00684 35.9883L4.77344 35.6094L10.0615 32.9951C10.2354 32.9386 10.4345 32.8937 10.5625 32.8936C10.7495 32.8936 10.9279 32.9381 11.1133 33.0771L11.1211 33.084L11.1309 33.0898C14.2527 35.1285 17.8278 36.0871 21.5957 35.7041C29.1901 35.0011 35.2528 29.0032 36.0195 21.4082C36.5303 16.5563 34.8054 11.8305 31.3584 8.44727Z" fill="#012169" stroke="#012169" stroke-width="0.666667" />
                                            <path d="M21.1221 14.9922H23.0634V22.3566H23.1636L28.2438 14.9922H30.0005V25.7961H28.0433V18.437H27.9536L22.8577 25.7961H21.1221V14.9922Z" fill="#012169" />
                                            <path d="M10.1113 14.9922H12.0527V22.3566H12.1529L17.233 14.9922H18.9897V25.7961H17.0326V18.437H16.9429L11.8469 25.7961H10.1113V14.9922Z" fill="#012169" />
                                        </svg></div>
                                </TooltipItem>
                            }
                        </div>
                        ||
                        <h1 className="mb-8 text-black">Диаграмма Ишикавы</h1>
                    }
                    {customLoading &&
                        <div className="flex items-center justify-center w-full mt-5 mb-5">
                            <Loading />
                        </div>
                        ||
                        <>
                            <FlexRow id="collapsible_tree" style={{ zIndex: 100 }} className='gap-[10px] w-full relative'>
                                <Collapsible open={true} trigger={
                                    <FlexRow className={twMerge(
                                        "w-full max-w-[708px] gap-[10px] bg-white",
                                        flatMobileView && "max-w-none",
                                        type5Way === FiveWhyType && 'relative'
                                    )}>

                                        {!flatMobileView && renderTree.length > 0 &&
                                            <div style={{ zIndex: 500, height: `${distance - 26}px`, width: "18px" }} className="treeElem-border absolute top-[42px] left-[12px] border-l border-[#9CA3AF]" />
                                        }

                                        {!flatMobileView && renderTree.length === 0 &&
                                            <FlexRow className="mt-[20px]">
                                                <Circle />
                                            </FlexRow> ||
                                            !flatMobileView && <>
                                                <FlexRow title="Свернуть" className="main_tree_minus mt-[20px] cursor-pointer hover:text-[#012169] text-[#8899A8]">
                                                    <RoundBoxMinusTree />
                                                </FlexRow>
                                                <FlexRow title="Развернуть" className="main_tree_plus mt-[20px] cursor-pointer hover:text-[#012169] text-[#8899A8]">
                                                    <RoundBoxPlusTree />
                                                </FlexRow>
                                            </>
                                        }
                                        {type5Way === FiveWhyType &&
                                            <div className={twMerge(
                                            "w-full rounded-md bg-[#FEF3C7] border border-[#F2A900] p-2.5 mb-2.5",
                                            flatMobileView && "min-w-0 flex-1 p-4 mb-4"
                                        )}>
                                                <div onPointerDown={(e) => e.stopPropagation()}
                                                    onClick={(e) => e.stopPropagation()}
                                                    className="flex flex-col items-start gap-1">
                                                    <strong className="shrink-0 w-full mb-2">Сформулируйте проблему, выявленную при выполнении шагов 1 и 2</strong>
                                                    {!viewMode &&
                                                        <textarea
                                                            value={problemInTree}
                                                            rows={problemRows}
                                                            onChange={(e) => setProblemInTree(e.target.value)}
                                                            className="overflow-hidden w-full flex-1 bg-transparent border-none outline-none ring-0 focus:outline-none focus:ring-0 focus:border-none resize-none p-0 text-gray-900 caret-gray-900"
                                                            onKeyDown={(e) => {
                                                                if (e.key !== " " && e.key !== "Enter") {
                                                                    return;
                                                                }

                                                                e.preventDefault();
                                                                e.stopPropagation();

                                                                const textarea = e.currentTarget;
                                                                const start = textarea.selectionStart;
                                                                const end = textarea.selectionEnd;

                                                                const valueToInsert = e.key === "Enter" ? "\n" : " ";

                                                                const newValue =
                                                                    problemInTree.slice(0, start) +
                                                                    valueToInsert +
                                                                    problemInTree.slice(end);

                                                                setProblemInTree(newValue);

                                                                // Возвращаем курсор после вставленного символа
                                                                requestAnimationFrame(() => {
                                                                    const newPosition = start + valueToInsert.length;

                                                                    textarea.focus();
                                                                    textarea.setSelectionRange(newPosition, newPosition);
                                                                });
                                                            }}
                                                            placeholder="Детально сформулируйте выявленную проблему"
                                                        /> ||
                                                        <div className="w-full whitespace-pre-wrap">
                                                            {problemInTree}
                                                        </div>
                                                    }
                                                </div>
                                            </div> ||
                                            <div className="w-full rounded-md bg-[#FEF3C7] border border-[#F2A900] p-2.5 mb-2.5">
                                                <strong>Проблема: </strong> {detailProplem}
                                            </div>
                                        }
                                        {type5Way === FiveWhyType &&
                                            <>
                                                {!viewMode && renderTree.length === 0 &&
                                                    <FlexRow title="Добавить Почему" className="text-[#8899A8] mt-[20px] xs:mt-0 xs:mb-[20px] xs:items-center cursor-pointer hover:text-[#012169]" onClick={(e) => {
                                                        e.stopPropagation();
                                                        if (problemInTree.length > 0) {
                                                            addTreeHandle({ level: 1 });
                                                        } else {
                                                            SetShowAddProblemInTreeModal(true);
                                                        }
                                                    }}>
                                                        <CirclePlus />
                                                    </FlexRow>
                                                }
                                            </>
                                        }

                                    </FlexRow>
                                }>
                                    {renderTree.length > 0 && renderTree.map((item: any) => item)}
                                </Collapsible>
                                {!viewMode && type5Way === 'DeviationReport' &&
                                    <Menu as="div" className="absolute left-[720px] flex text-left mt-[20px]">
                                        {({ open }) => (
                                            <>
                                                <Menu.Button
                                                    onClick={(e) => e.stopPropagation()}
                                                    title="Добавить категорию Ишикавы"
                                                    className={twMerge(open ? "button-state-active" : "", "flex rounded-lg button-state hover:text-[#012169] text-[#8899A8]")}
                                                >
                                                    <CirclePlus />
                                                </Menu.Button>

                                                <Transition
                                                    as={Fragment}
                                                    enter="transition ease-out duration-100"
                                                    enterFrom="transform opacity-0 scale-95"
                                                    enterTo="transform opacity-100 scale-100"
                                                    leave="transition ease-in duration-75"
                                                    leaveFrom="transform opacity-100 scale-100"
                                                    leaveTo="transform opacity-0 scale-95"
                                                >
                                                    <Menu.Items style={{ zIndex: 13000 }} className="absolute top-0 origin-top-right ml-2.5 bg-white rounded-lg left-full shadow-custom ring-1 ring-black ring-opacity-5 focus:outline-none min-w-[180px]">
                                                        {categories.map((item: any) => (
                                                            <Menu.Item disabled={item.ID === 19 && true || false} key={item.ID}>
                                                                <FlexRow onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    addTreeHandle({ level: 1, category: item.Title });
                                                                }} className={`${item.ID === 19 && "cursor-not-allowed" || "cursor-pointer"} items-center px-[20px] py-[8px] gap-x-2 hover:bg-[#F5F7FD]`}>
                                                                    <div className="flex flex-col text-[#012169]">{item.Title}</div>
                                                                </FlexRow>
                                                            </Menu.Item>
                                                        ))}
                                                    </Menu.Items>
                                                </Transition>
                                            </>
                                        )}
                                    </Menu>
                                }
                            </FlexRow>
                            {!viewMode && type5Way === 'DeviationReport' &&
                                <Menu style={{ marginLeft: '35px' }} as="div" className="relative flex text-left w-full max-w-[708px]">
                                    {({ open }) => (
                                        <>
                                            <Menu.Button
                                                onClick={(e) => e.stopPropagation()}
                                                className={twMerge(open ? "button-state-active border-[#012169] text-[#012169]" : "border-[#8646F4] text-[#8646F4]",
                                                    "flex items-center rounded-lg button-state w-full rounded-md flex p-[20px]  border")}
                                            >
                                                <AddButton />
                                                Добавить категорию Ишикавы
                                            </Menu.Button>

                                            <Transition
                                                as={Fragment}
                                                enter="transition ease-out duration-100"
                                                enterFrom="transform opacity-0 scale-95"
                                                enterTo="transform opacity-100 scale-100"
                                                leave="transition ease-in duration-75"
                                                leaveFrom="transform opacity-100 scale-100"
                                                leaveTo="transform opacity-0 scale-95"
                                            >
                                                <Menu.Items style={{ top: "calc(100% + 10px)", zIndex: 130 }} className="absolute origin-top-right ml-2.5 bg-white rounded-lg left-[20px] shadow-custom ring-1 ring-black ring-opacity-5 focus:outline-none min-w-[180px]">
                                                    {categories.map((item: any) => (
                                                        <Menu.Item disabled={item.ID === 19 && true || false} key={item.ID}>
                                                            <FlexRow onClick={(e) => {
                                                                e.stopPropagation();
                                                                addTreeHandle({ level: 1, category: item.Title });
                                                            }} className={`${item.ID === 19 && "cursor-not-allowed" || "cursor-pointer"} items-center px-[20px] py-[8px] gap-x-2 hover:bg-[#F5F7FD]`}>
                                                                <div className="flex flex-col text-[#012169]">{item.Title}</div>
                                                            </FlexRow>
                                                        </Menu.Item>
                                                    ))}
                                                </Menu.Items>
                                            </Transition>
                                        </>
                                    )}
                                </Menu>
                            }
                            {editData &&
                                <footer className="flex justify-between w-full px-10 pt-10 mt-4 border-t">
                                    <TGButton type="button" color="white" onClick={(e) => {
                                        e.stopPropagation();
                                        resetTreeHandle()
                                    }}>
                                        Отмена
                                    </TGButton>
                                    <TGButton type="button" color="bluedark" onClick={(e) => {
                                        e.stopPropagation();
                                        saveTreeHandle()
                                    }}>
                                        Сохранить
                                    </TGButton>
                                </footer>
                            }
                            {flatMobileView && viewMode &&
                                <footer className="flex justify-center w-full px-10 pt-6 mt-2 border-t">
                                    <TGButton type="button" color="white" onClick={(e) => {
                                        e.stopPropagation();
                                        setOpen(false);
                                    }}>
                                        Закрыть
                                    </TGButton>
                                </footer>
                            }
                        </>
                    }
                </div>
                <Modal zIndex={zIndex ? zIndex + 10 : 70} modalClassName="min-h-px" open={showAddProblemInTreeModal} toggleDialog={SetShowAddProblemInTreeModal}>
                    <div className="px-10 py-5">
                        <p>
                            Пожалуйста сначала сформулируйте проблему, выявленную при выполнении шагов 1 и 2
                        </p>
                    </div>

                    <footer className="flex justify-center w-full px-10 pt-10 mt-4 border-t">
                        <TGButton type="button" color="white" onClick={(e) => {
                            e.stopPropagation();
                            SetShowAddProblemInTreeModal(!showAddProblemInTreeModal)
                        }}>
                            Закрыть
                        </TGButton>
                    </footer>
                </Modal>

                <Modal zIndex={zIndex ? zIndex + 10 : 70} modalClassName="min-h-px" open={removeModalShow} toggleDialog={setRemoveModalShow}>
                    <header className="px-10 pb-4">
                        <h2>Подтвердите действие</h2>
                    </header>

                    <div className="px-10 py-5">
                        {removeTreeItemCategory &&
                            <p>
                                Вы уверены, что хотите удалить категорию Ишикавы?<br />
                                Все дочерние Почему тоже будут удалены.
                            </p>
                            ||
                            <p>
                                Вы уверены, что хотите удалить это Почему?<br />
                                Все дочерние Почему тоже будут удалены.
                            </p>
                        }
                    </div>

                    <footer className="flex justify-center justify-between w-full px-10 pt-10 mt-4 border-t">
                        <TGButton type="button" color="white" onClick={(e) => {
                            e.stopPropagation();
                            setRemoveModalShow(!removeModalShow)
                        }}>
                            Отмена
                        </TGButton>
                        <TGButton type="button" color="bluedark" onClick={(e) => {
                            e.stopPropagation();
                            removeTreeHandleCurrent(removeTreeItemKey)
                        }}>
                            Удалить
                        </TGButton>
                    </footer>
                </Modal>
                <Modal zIndex={zIndex ? zIndex + 10 : 70} modalClassName="min-h-px" open={noticeMedal} toggleDialog={setNoticeMedal}>
                    <div className="px-10 py-5">
                        <p>
                            Отменить корневую причину нельзя, так как за ней закреплён SDCA инструмент.<br />Сначала удалите SDCA инструмент в карточке.<br />Если были запланированы действия, то они останутся в совещаниях.
                        </p>
                    </div>

                    <footer className="flex justify-center w-full px-10 pt-10 mt-4 border-t">
                        <TGButton type="button" color="white" onClick={(e) => {
                            e.stopPropagation();
                            setNoticeMedal(!noticeMedal)
                        }}>
                            Закрыть
                        </TGButton>
                    </footer>
                </Modal>
                <Modal zIndex={zIndex ? zIndex + 10 : 70} modalClassName="min-h-px" open={noticeTreeItem} toggleDialog={setNoticeTreeItem}>
                    <div className="px-10 py-5">
                        <p>
                            Пожалуйста, сначала укажите "Потому что ..."
                        </p>
                    </div>
                    <footer className="flex justify-center w-full px-10 pt-10 mt-4 border-t">
                        <TGButton type="button" color="white" onClick={(e) => {
                            e.stopPropagation();
                            setNoticeTreeItem(!noticeTreeItem)
                        }}>
                            Закрыть
                        </TGButton>
                    </footer>
                </Modal>
                <Modal zIndex={zIndex ? zIndex + 10 : 70} modalClassName="min-h-px" open={reasonTreeItem} toggleDialog={setReasonTreeItem}>
                    <div className="px-10 py-5">
                        <p>
                            Пожалуйста, сначала укажите Причину...
                        </p>
                    </div>
                    <footer className="flex justify-center w-full px-10 pt-10 mt-4 border-t">
                        <TGButton type="button" color="white" onClick={(e) => {
                            e.stopPropagation();
                            setReasonTreeItem(!reasonTreeItem)
                        }}>
                            Закрыть
                        </TGButton>
                    </footer>
                </Modal>
            </DrawerComponent >
            <div id="screenshotTree" style={{ display: 'none', flexDirection: 'column', padding: '24px', gap: '16px' }}>
                {type5Way === FiveWhyType &&
                    <h1 style={{ color: '#000' }}>Дерево почему</h1>
                    ||
                    <h1 style={{ color: '#000' }}>Диаграмма Ишикавы</h1>
                }
                <div style={{ zIndex: 100, gap: '10px', width: '100%', position: 'relative' }}>
                    <FlexRow style={{ width: '100%', maxWidth: '708px', gap: '10px', backgroundColor: '#fff', position: 'relative' }}>
                        <div style={{ width: '100%', borderRadius: '8px', backgroundColor: '#FEF3C7', border: '1px solid #F2A900', padding: '16px', marginBottom: '16px' }}>
                            <strong>Проблема: </strong> {detailProplem}
                        </div>
                    </FlexRow>
                    {renderScreenshotTree.length > 0 && renderScreenshotTree.map((item: any) => item)}
                </div>
            </div>
        </>
    );
};

export default Tree;
